import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

function NoResults(){
    return(
        <div className="flex flex-col justify-items-center items-center dark:bg-gray-900 mb-5">
            <FontAwesomeIcon icon={faExclamationTriangle} className="mt-16 text-red-600 dark:text-white" size="10x" aria-hidden="true" />
            <h1 className="text-red-600 font-extrabold text-3xl mt-10 dark:text-white">Record Not Found!</h1>
            <p className="text-xl text-center text-black mt-12 dark:text-white">We have no records for the driver license you provided. Check for mistakes and try again. <br/>Please contact your nearest DMV for assistance</p>
            <Link className="w-3/4" to="/">
            <div className="mt-5 mx-auto text-center sm:w-3/4 md:w-1/2 sm:px-3 sm:py-3 font-large rounded-md shadow-sm text-white bg-gradient-to-r from-blue-600 to-blue-900 hover:from-blue-700 hover:to-blue-900">
                Return to Search Page
            </div>
            </Link>
        </div>

    )
}

export default NoResults;